module.exports = require("core-js/modules/es.typed-array.uint8-array.js");